/* ============================================================
   FLY TO BAG
   Pressing an Add button throws a bag icon along a lofted arc
   up to the bag button, growing as it travels.

   Hooked with a CAPTURE-phase delegated listener rather than by
   editing quickAdd(): the Add buttons carry inline onclick
   handlers that call preventDefault, and new cards get injected
   at runtime (recently-viewed, quick view). Delegation catches
   all of them, present and future, and fires on the press
   rather than after the fetch so it feels immediate.
   ============================================================ */
(function () {
  'use strict';

  var DUR = 760;
  var TRIGGERS = '.prod-add, #qvAtc, .quick-view__atc, #atcBtn, .sticky-atc__btn';

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function visible(el) {
    if (!el || !el.offsetParent && getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  /* the header bag on desktop, the bottom bar on phones */
  function bagRect() {
    var order = [
      document.querySelector('.nav-bag-btn'),
      document.querySelector('.bottom-nav__badge'),
      document.querySelector('.bottom-nav__item:last-child')
    ];
    for (var i = 0; i < order.length; i++) {
      if (visible(order[i])) return order[i].getBoundingClientRect();
    }
    return null;
  }

  function bagIcon() {
    var el = document.createElement('div');
    el.className = 'fb-fly';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
      '<line x1="3" y1="6" x2="21" y2="6"/>' +
      '<path d="M16 10a4 4 0 01-8 0"/></svg>';
    return el;
  }

  function fly(from) {
    var to = bagRect();
    if (!to) return;

    var x0 = from.left + from.width / 2,
        y0 = from.top + from.height / 2,
        x1 = to.left + to.width / 2,
        y1 = to.top + to.height / 2;

    /* Control point above both ends so it lofts instead of
       sliding flat. Tied to the horizontal distance so short
       throws stay tight and long ones arc more. */
    var cx = (x0 + x1) / 2;
    var cy = Math.min(y0, y1) - Math.max(70, Math.abs(x1 - x0) * 0.30);

    var el = bagIcon();
    document.body.appendChild(el);

    var t0 = performance.now();

    function step(now) {
      var p = Math.min((now - t0) / DUR, 1);
      var e = 1 - Math.pow(1 - p, 2.1);          /* ease out */
      var m = 1 - e;

      /* quadratic bezier */
      var x = m * m * x0 + 2 * m * e * cx + e * e * x1;
      var y = m * m * y0 + 2 * m * e * cy + e * e * y1;

      var s = 0.32 + 1.03 * e;                   /* small -> big */
      var o = p < 0.07 ? p / 0.07
            : p > 0.85 ? Math.max(0, (1 - p) / 0.15)
            : 1;

      el.style.transform =
        'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) ' +
        'translate(-50%,-50%) scale(' + s.toFixed(3) + ') rotate(' + (e * 16).toFixed(1) + 'deg)';
      el.style.opacity = o;

      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        if (el.parentNode) el.parentNode.removeChild(el);
        land();
      }
    }
    requestAnimationFrame(step);
  }

  /* a small knock on the bag as it arrives */
  function land() {
    var b = document.querySelector('.nav-bag-btn');
    var c = document.querySelector('.bottom-nav__badge');
    [b, c].forEach(function (el) {
      if (!visible(el)) return;
      el.classList.remove('fb-hit');
      void el.offsetWidth;
      el.classList.add('fb-hit');
      setTimeout(function () { el.classList.remove('fb-hit'); }, 520);
    });
  }

  document.addEventListener('click', function (e) {
    if (reduced()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(TRIGGERS);
    if (!btn || btn.disabled || btn.classList.contains('adding')) return;
    fly(btn.getBoundingClientRect());
  }, true);
})();
